
export class UserLinkModel {
  url: string;
}
